import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function checkincome(code) {
    let rs = ""
    if (code) {
        let url = "CSINCOME/GETCODESCSINCOME?Code=" + code
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 5000 }).then((res) => {
            if (res.data.length > 0) {
                rs =  res.data[0].MYNAMETH
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    return rs
};